import React, { useState, useCallback, useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import MobileFormContentManager from "../../components/common/mobile/MobileFormContentManager";
import * as designMeta from "../../api/design/meta";
import DesignTreePicker from "../../components/design/DesignTreePicker";
import TinyMCEeditor from "../../components/const/TinyMCEeditor";
import MobilePeopleCellLoader from "../../components/common/people/MobilePeopleCellLoader";
import { getDocPersons } from "../../api/papers";

export default function Fcn_new() {
  const { id: projectId, dns : paramDns } = useParams();
  const location = useLocation();
  const [showDesignPicker, setShowDesignPicker] = useState(false);
  const [activeRow, setActiveRow] = useState(null);

  const reasonEditorRef = useRef(null);

  const [requestPeople, setRequestPeople] = useState([]);

  const [form, setForm] = useState({
    title: "",
    reason: "",
    attachments: [],
    details: [{ id: 1, item: "", before: "", after: "", note: "" }],
    alert: {
      send: true,
      urgent: false,
      departments: [],
    },
  });

  /* ---------------------------------------------------
       수정 모드: 기존 meta 로드
    --------------------------------------------------- */
    useEffect(() => {
      if (!paramDns) return; // new 모드
  
      const load = async () => {
        try {
          const res = await designMeta.getMeta({ dns: paramDns });
          const meta = res.meta || res.data?.meta || {};
  
          const loadedPeople = await getDocPersons(paramDns);
  
          setDns(paramDns);
  
          setRequestPeople(loadedPeople);
  
          setForm({
            title: meta.title || "",
            requestDept: meta.requestDept || "",
            reason: meta.reason || "",
            attachments: meta.attachments || [],
            details: meta.details || [],
            alert: meta.alert || {
              send: true,
              urgent: false,
              departments: (loadedPeople || []).map((p) => p.id),
            },
          });
        } catch (e) {
          console.error(e);
          alert("기존 문서를 불러오지 못했습니다.");
        }
      };
  
      load();
    }, [paramDns]);

  const [dns, setDns] = useState("");
  const [linkedFcr, setLinkedFcr] = useState(null);
  const [fcrList, setFcrList] = useState([]);

  const getBody = useCallback(() => {
    const html = reasonEditorRef.current?.getContent() || "";

    return {
      values: {
        project: projectId,
        module: "design",
        doc_type: "FCN",
        dns,
        related_dns: linkedFcr?.doc_dns || null,

        title: form.title,

        meta: {
          title: form.title,
          reason: html || form.reason,
          requestPeople: requestPeople.map((p) => p.user?.id || p.id),

          details: form.details.map((d) => ({
            id: d.id,
            item: d.item,
            before: d.before,
            after: d.after,
            note: d.note,
            drawingFileId: d.drawingFileId || null,
            drawingFileUrl: d.drawingFileUrl || "",
          })),

          alert: {
            send: form.alert?.send !== undefined ? form.alert.send : true,
            urgent: form.alert?.urgent || false,
            departments: requestPeople.map((p) => p.user?.id || p.id),
          },

          attachments: form.attachments || [],
          linkedFcr: linkedFcr?.doc_dns || null,
        },
      },
    };
  }, [form, dns, linkedFcr, projectId, requestPeople]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const fcr_dns = params.get("fromFCR");
    if (fcr_dns) loadFcr(fcr_dns);
  }, [location.search, projectId]);

  useEffect(() => {
    const fetchFcrList = async () => {
      try {
        const res = await designMeta.getMetaMyList({
          project: projectId,
          doc_type: "FCR",
        });
        console.log("불러온 FCR 목록:", res);
        setFcrList(Array.isArray(res.results) ? res.results : []);
      } catch (err) {
        console.error("FCR 목록 불러오기 실패:", err);
      }
    };
    fetchFcrList();
  }, [projectId]);

  const loadFcr = async (fcr_dns) => {
    try {
      const res = await designMeta.getMeta({ dns: fcr_dns });
      const fcr = res.data || res;
      setLinkedFcr(fcr);

      const meta = fcr.meta || {};

      const loadedPeople = await getDocPersons(fcr_dns);
      setRequestPeople(loadedPeople);
      
      setForm(prev => ({
        ...prev,

        title: meta.title
          ? `${meta.title} (설계변경 통보)`
          : prev.title || "설계변경 통보서",

        reason: prev.reason || meta.reason ||
          "FCR 요청에 따라 설계 변경을 반영하고 통보합니다.",

        attachments: prev.attachments,

        details: (meta.details || prev.details).map((d, i) => ({
          id: i + 1,
          item: d.drawingNo || d.item || "",
          drawingFileId: d.drawingFileId || null,
          drawingFileUrl: d.drawingFileUrl || "",
          before: d.original || d.before || "",
          after: d.changed || d.after || "",
          note: d.cause || d.note || "",
        })),
      }));

    } catch (err) {
      console.error("FCR 불러오기 실패:", err);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleDetailChange = (index, key, value) => {
    setForm((prev) => {
      const updated = [...prev.details];
      updated[index][key] = value;
      return { ...prev, details: updated };
    });
  };

  const addDetailRow = () =>
    setForm((prev) => ({
      ...prev,
      details: [
        ...prev.details,
        { id: prev.details.length + 1, item: "", before: "", after: "", note: "" },
      ],
    }));

  const removeDetailRow = (i) =>
    setForm((prev) => ({
      ...prev,
      details: prev.details.filter((_, idx) => idx !== i),
    }));

  return (
    <div className="mobile-page-root mb-16">
      <div className="mobile-page-root-inner space-y-3">
      <MobileFormContentManager
      params={{
        module: "design",
        doc_type: "FCN",
        project: projectId,
        dns,
        related_dns: linkedFcr?.doc_dns || null,
      }}
      getBody={getBody}
      onChangeId={(newDns) => setDns(newDns)}
      redirectTo={`/project/${projectId}/design/list`}
      docName={"설계변경통보서 (FCN)"}
      docDescribe={"설계 변경 사항을 통보할 때 아래 내용을 작성하세요."}
      requestPeople={requestPeople}
      hideBackButton={true}
      summaryConfig={{
        title: "통보서 요약",
        sections: [
          { label: "제목", value: form.title },
          { label: "통보 담당자", value: requestPeople.map((r)=> r.user?.name || r.name).join(", ") || "-"},
        ],
        list: [
          {
            label: "변경 항목",
            items: form.details?.map(
              (d) => `${d.item || "-"}: ${d.before || "-"} → ${d.after || "-"}`
            ),
          },
        ],
        footerNote: "입력한 내용이 실시간으로 반영됩니다.",
      }}
    >
      <div className="space-y-2 w-full min-w-0 max-w-full overflow-x-hidden">
        {/* 연결된 FCR */}
        <div className="bg-white rounded-lg border p-2 min-w-0 overflow-x-hidden" style={{ width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>
          <label className="text-[11px] text-gray-500 mb-0.5 block">연결된 FCR</label>
          {linkedFcr ? (
            <div className="text-xs text-gray-900 font-medium">{linkedFcr.doc_dns}</div>
          ) : (
            <select
              className="w-full min-w-0 border border-gray-200 rounded px-2 py-1 text-xs focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              onChange={(e) => loadFcr(e.target.value)}
              style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
            >
              <option value="">선택하세요</option>
              {fcrList.map((fcr) => (
                <option key={fcr.doc_dns} value={fcr.doc_dns}>
                  {fcr.doc_dns} - {fcr.title}
                </option>
              ))}
            </select>
          )}
        </div>

        {/* 기본 정보 */}
        <div className="bg-white rounded-lg border overflow-hidden min-w-0" style={{ width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>
          <div className="bg-gray-50 px-2 py-1.5 border-b min-w-0 overflow-x-hidden">
            <div className="text-xs font-medium text-gray-900 min-w-0 truncate">기본 정보</div>
          </div>
          <div className="p-2 space-y-2 min-w-0 overflow-x-hidden">
            {/* 통보 제목 */}
            <div>
              <label htmlFor="fcn-title" className="text-[11px] text-gray-500 mb-0.5 block">
                통보 제목
              </label>
              <input
                id="fcn-title"
                name="title"
                type="text"
                value={form.title}
                onChange={handleChange}
                className="w-full min-w-0 border border-gray-200 rounded px-2 py-1.5 text-xs focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="예: 벽체 두께 변경에 따른 구조 보강 통보"
                style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
              />
            </div>

            {/* 통보 담당자 */}
            <div>
              <label className="text-[11px] text-gray-500 mb-0.5 block">
                통보 담당자
              </label>
              <div className="border border-gray-200 rounded px-2 py-1.5 bg-gray-50 min-w-0 overflow-x-hidden">
                <MobilePeopleCellLoader
                  dns={linkedFcr?.doc_dns || dns}
                  value={requestPeople}
                  onChange={(list) => setRequestPeople(list)}
                />
              </div>
            </div>

            {/* 변경 사유 */}
            <div className="min-w-0">
              <label className="text-[11px] text-gray-500 mb-0.5 block">
                변경 사유
              </label>
              <div className="border border-gray-200 rounded overflow-hidden min-w-0" style={{ width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>
                <div className="min-w-0 max-w-full overflow-x-hidden" style={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
                  <div style={{ width: '100%', maxWidth: '100%', overflow: 'hidden', boxSizing: 'border-box' }}>
                    <TinyMCEeditor
                      height={250}
                      initialValue={form.reason}
                      editorRef={reasonEditorRef}
                      onChange={(v) =>
                        setForm((prev) => ({ ...prev, reason: v }))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 변경 항목 내역 */}
        <div className="bg-white rounded-lg border overflow-hidden min-w-0" style={{ width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>
          <div className="bg-gray-50 px-2 py-1.5 border-b flex items-center justify-between min-w-0 overflow-x-hidden">
            <div className="text-xs font-medium text-gray-900 min-w-0 flex-1 truncate">변경 항목 내역</div>
            <button
              onClick={addDetailRow}
              className="btn-create-sm flex-shrink-0 whitespace-nowrap"
            >
              + 추가
            </button>
          </div>
          <div className="p-2 space-y-1.5 min-w-0 overflow-x-hidden">
            {form.details.map((row, i) => (
              <div key={row.id} className="bg-gray-50 rounded border border-gray-200 p-1.5 space-y-1.5 min-w-0 overflow-x-hidden" style={{ width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>
                <div className="flex items-center justify-between mb-1 min-w-0">
                  <span className="text-[11px] font-medium text-gray-700 min-w-0 flex-1 truncate">No. {i + 1}</span>
                  <button
                    onClick={() => removeDetailRow(i)}
                    className="btn-delete-sm flex-shrink-0 whitespace-nowrap ml-1.5"
                  >
                    삭제
                  </button>
                </div>

                {/* 항목 */}
                <div>
                  <label className="text-[11px] text-gray-500 mb-0.5 block">항목</label>
                  {row.drawingFileId ? (
                    <div className="flex items-center justify-between w-full border border-gray-200 rounded px-2 py-1 bg-white min-w-0">
                      <span className="truncate flex-1 min-w-0 text-xs">
                        {row.item}
                      </span>
                      <button
                        onClick={() => {
                          handleDetailChange(i, "drawingFileId", null);
                          handleDetailChange(i, "drawingFileUrl", "");
                          handleDetailChange(i, "item", "");
                        }}
                        className="ml-1.5 text-red-500 hover:text-red-600 text-[10px] flex-shrink-0"
                        title="선택 해제"
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <div className="flex items-center gap-1.5 min-w-0">
                      <input
                        type="text"
                        value={row.item}
                        onChange={(e) => handleDetailChange(i, "item", e.target.value)}
                        className="flex-1 min-w-0 border border-gray-200 rounded px-1.5 py-1 text-xs focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="도면번호 또는 선택"
                        style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                      />
                      <button
                        onClick={() => {
                          setActiveRow(i);
                          setShowDesignPicker(true);
                        }}
                        className="px-1.5 py-1 border border-gray-200 rounded text-[11px] hover:bg-gray-100 transition-colors flex-shrink-0 whitespace-nowrap"
                        title="설계도서에서 선택"
                      >
                        📂
                      </button>
                    </div>
                  )}
                </div>

                {/* 변경 전 내용, 변경 후 내용 (2열 그리드) */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 min-w-0">
                  <div className="min-w-0">
                    <label className="text-[11px] text-gray-500 mb-0.5 block">변경 전</label>
                    <input
                      type="text"
                      value={row.before}
                      onChange={(e) => handleDetailChange(i, "before", e.target.value)}
                      className="w-full min-w-0 border border-gray-200 rounded px-1.5 py-1 text-xs focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                    />
                  </div>
                  <div className="min-w-0">
                    <label className="text-[11px] text-gray-500 mb-0.5 block">변경 후</label>
                    <input
                      type="text"
                      value={row.after}
                      onChange={(e) => handleDetailChange(i, "after", e.target.value)}
                      className="w-full min-w-0 border border-gray-200 rounded px-1.5 py-1 text-xs focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                    />
                  </div>
                </div>

                {/* 변경 사유 */}
                <div>
                  <label className="text-[11px] text-gray-500 mb-0.5 block">변경 사유</label>
                  <input
                    type="text"
                    value={row.note}
                    onChange={(e) => handleDetailChange(i, "note", e.target.value)}
                    className="w-full min-w-0 border border-gray-200 rounded px-1.5 py-1 text-xs focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {linkedFcr && (
          <div className="mt-4 text-sm text-slate-600">
            ※ 본 문서는{" "}
            <a
              href={`/project/${projectId}/design/fcr/${linkedFcr.doc_dns}`}
              className="text-indigo-600 underline hover:text-indigo-800"
              target="_blank"
              rel="noopener noreferrer"
            >
              FCR ({linkedFcr.doc_dns})
            </a>{" "}
            요청서를 기반으로 작성되었습니다.
          </div>
        )}
      </div>
      {showDesignPicker && (
        <DesignTreePicker
          open={showDesignPicker}
          onClose={() => setShowDesignPicker(false)}
          onConfirm={(file) => {
            handleDetailChange(activeRow, "item", file.name || file.title);
            handleDetailChange(activeRow, "drawingFileId", file.id);
            handleDetailChange(activeRow, "drawingFileUrl", file.file_url || file.url || "");
          }}
        />
      )}
    </MobileFormContentManager>
      </div>
    </div>
  );
}